import { Box, Typography } from '@mui/material';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';
import { truncateWithEllipsis } from '@/ui/utils/truncate-text';

const CITY_LABEL_WIDTH = 60;

export function CityLabel({ tourTravel }: { tourTravel: TourTravel }) {
  let text;
  let textAlign;
  switch (tourTravel.connexionTypeWithEvent) {
    case 'incoming':
      text = tourTravel.fromPosition?.properties.name || '';
      textAlign = 'right';
      break;
    case 'outgoing':
      text = tourTravel.toPosition?.properties.name || '';
      textAlign = 'left';
      break;
    default:
      text = '';
      textAlign = 'left';
  }
  return (
    <Box sx={{ width: CITY_LABEL_WIDTH }}>
      <Typography
        noWrap
        sx={{
          fontSize: '0.75rem',
          fontWeight: 400,
          textAlign: textAlign,
        }}
      >
        {truncateWithEllipsis(text, 20)}
      </Typography>
    </Box>
  );
}
